<template>
  <div class="ic-modal-body">
    <h2 class="ic-modal-body__title" v-text="subscription.editText" />
    <p v-if="errorBody" class="ic-modal-body__error-body" v-text="errorBody" />
    <p class="ic-modal-body__subscription-name" v-text="subscription.name" />
    <p
      class="ic-modal-body__perks-heading"
      v-if="subscriptionPerks"
      v-text="subscription.perksHeading"
    />
    <ul v-if="subscriptionPerks" class="ic-modal-body__perks">
      <li class="ic-modal-body__perk" v-for="perk in subscriptionPerks">
        <span>Unlimited</span> {{ perk }}
      </li>
    </ul>
    <div class="ic-modal-body__form-buttons">
      <button
        type="submit"
        class="ic-modal-body__form-button"
        :class="{
          'ic-modal-body__form-button--loading': isSubmitting
        }"
        v-text="submitButtonText"
        :disabled="isSubmitting"
        v-touch:tap="updateSubscription"
      />
      <button
        class="ic-modal-body__form-button ic-modal-body__form-button--cancel"
        :disabled="isSubmitting"
        v-touch:tap="closeModal"
        v-text="cancelButtonText"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ic-edit-subscription',
  props: {
    // Subscription
    subscription: {
      type: Object,
      required: true
    },
    // Array of Subscription perks to list
    subscriptionPerks: {
      type: Array,
      required: true
    },
    // Text to display for the submit button
    submitButtonText: {
      type: String,
      required: true
    },
    // Text to display for the cancel button
    cancelButtonText: {
      type: String,
      required: true
    },
    // Checks if form is being submitted
    isSubmitting: {
      type: Boolean,
      required: true
    },
    // Error message when endpoint fails
    errorBody: {
      type: String
    }
  },
  methods: {
    closeModal() {
      this.$emit('edit-subscription-close-modal');
    },
    /**
     * updatesSubscription
     * @param event
     */
    updateSubscription(event) {
      event.preventDefault();

      this.$emit('edit-subscription', this.subscription);
    }
  }
};
</script>
